import React, { useState } from 'react'
import menuIcon from '../../assets/menu-icon.svg'
import { getTenantInfoByKey } from '../../helpers/helpers';
import Sidebar from '../Sidebar/Sidebar';

const NavBody = ({ children, rowAlignment = 'align-items-center', leftColClassName = 'col', midColClassName = 'col-xl-4 col-lg-7 col-sm-9 mt-3 mt-sm-0', rightColClassName = 'col' }) => {
 
    const isSelectionScreen = ['/selectAccessOpening','/selectAccessBuildings'].some(route=>route===window.location.pathname);
 
    const instanceLogo = getTenantInfoByKey('image_path');

    const [openMenu, setOpenMenu] = useState(false);

    return (
        <>
            <Sidebar isOpen={openMenu} setIsOpen={() => setOpenMenu(!openMenu)} />
            <div className='w-100'>
                <div className={`row ${rowAlignment}`}>
                    <div className={leftColClassName}>
                        <div
                            className='rounded-circle white-bg'
                            style={{ width: '50px', height: '50px', border: '#D6DCE7 4px solid' }}
                        >
                            <img src={instanceLogo} alt="" className='w-100 h-100' style={{ objectFit: 'contain' }} />
                        </div>
                    </div>
                    <div className={`${midColClassName} order-sm-2 order-last`}>
                        {children}
                    </div>
                    <div className={`${rightColClassName} order-3`}>
                        {
                             isSelectionScreen===false?
                                <div className='d-flex justify-content-end'>
                                    <div
                                        type="button"
                                        aria-expanded="false"
                                        onClick={() => setOpenMenu(!openMenu)}
                                    >
                                        <img src={menuIcon} alt="" />
                                    </div>
                                </div>
                                :
                                null
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default NavBody